module.exports = __webpack_public_path__ + "static/media/selos_banner.abb4cbf0.jpeg";